import { render, staticRenderFns } from "./TarefaPrioridade.vue?vue&type=template&id=00dd041a&"
import script from "./TarefaPrioridade.vue?vue&type=script&lang=js&"
export * from "./TarefaPrioridade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports